//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CLDKin.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[0,"LastSelectedDevice",1,"NXObject",0],[0,"PoseName",1,0],[1,"SelectDevice",0,"SelectDisplayableObject",0]],[[[],"ApplyJoints",{},0,0],[["selectedPartOccTag"],"ApplyPose",{},1,0],[["sDlgTitle","eDlgState","sPoseName","tDeviceTag"],"SetJointJogBehaviour",{},4,0],[["nxkJoint","distance"],"AddJointToMap",{},2,0],[["nxkJoint","newValue"],"UpdateJointToMap",{},2,0],[[],"RemoveAllJointMap",{},0,0],[["nxkJoint","newValue"],"UpdateJointValuePairVector",{},2,0],[[],"ClearJointValuePairVector",{},0,0],[["partOccTag"],"DryApplyPoseForPartOcc",{},1,0],[["partOccTag","nxkJointTag"],"UpdatePartOccToJointVectorMapPtr",{},2,0],[[],"GetLastJoggedDevice",{R_:{lastDeviceJoggedDevice:"NXObject"}},0,0],[["lastDeviceJoggedDevice"],"SetLastJoggedDevice",{},1,0]],[]];
SPLM.CLDKin.JointJogBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CLDKin.JointJogBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;